module.exports = [
  // type
  require('./ResultSet')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/resultset/index.js
// module id = 1306
// module chunks = 0